











































import Vue from 'vue'
import { mapState } from 'vuex'
import DatePicker from '@/components/date-picker.vue'
import { getUsersActionsExcelReport } from '@/core/api/reports'

export default Vue.extend({
  components: {
    DatePicker,
  },
  data: () => ({
    loading: false,
    filter: {
      dateStart: null as any,
      dateEnd: null as any,
      user: undefined,
    },
  }),
  computed: mapState({
    user: (state: any) => state.auth.user,
    users: (state: any) => state.users.items,
  }),
  mounted() {
    this.filter.dateStart = this.$moment()
    this.filter.dateEnd = this.$moment()
  },
  methods: {
    submit() {
      this.loading = true
      getUsersActionsExcelReport(
        this.filter.dateStart.startOf('day').toDate(),
        this.filter.dateEnd.endOf('day').toDate(),
        this.filter.user,
      )
        .then(() => {
          this.$toastSuccess.fire({ title: 'Отчет успешно сформирован' })
        })
        .catch(() => {
          this.$toastError.fire()
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
})
